import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { useI18n } from "../lib/i18n";
import ListingCard from "../components/ListingCard";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { Heart } from "lucide-react";

export default function Favorites() {
  const { t } = useI18n();
  const { user, loading } = useAuth();
  const nav = useNavigate();
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState(true);

  useEffect(() => {
    if (loading) return;
    if (!user) { nav("/login"); return; }
    api.get("/favorites")
      .then(r => setItems(r.data))
      .catch(() => setItems([]))
      .finally(() => setBusy(false));
  }, [user, loading, nav]);

  if (loading || !user) return null;

  return (
    <div data-testid="favorites-page" className="pt-24 pb-20">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="overline text-[#143122] flex items-center gap-2">
          <Heart size={12} strokeWidth={1.5} /> {t("favorites")}
        </div>
        <h1 className="mt-2 font-serif-display text-4xl md:text-5xl text-[#143122]">
          {t("saved_listings")}
        </h1>

        <div className="mt-10">
          {busy ? (
            <div className="text-sm text-[#1A1F1C]/50">Loading...</div>
          ) : items.length === 0 ? (
            <div className="text-sm text-[#1A1F1C]/60 border border-dashed border-[#E6E2D8] rounded-lg py-16 text-center">
              {t("no_favorites")}
            </div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
              {items.map((l, i) => <ListingCard key={l.id} listing={l} index={i} />)}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
